import { GlobalStyles as ExternalGlobalStyles } from 'twin.macro';

const TailwindGlobalStyles = () => <ExternalGlobalStyles />;

TailwindGlobalStyles.displayName = 'TailwindGlobalStyles';

export default TailwindGlobalStyles;
